const CorporateActionDropDown = ({
  value,
  setValue,
  className,
  className1,
}) => {
  const handleAction = (e) => {
    setValue((prev) => ({
      ...prev,
      ["action"]: e.target.value,
    }));
  };

  return (
    <div
      className={` ${
        className ? className : "w-full"
      } flex h-full  flex-col gap-2 rounded-[4px] bg-[#F7F7F7]`}
    >
      <div className="h-full rounded bg-transparent px-[1px] py-[1px]">
        <select
          className={`${className1} w-full  bg-transparent py-[10px] text-[14px] text-[#868686]  focus:outline-none`}
          value={value?.action || ""}
          onChange={(e) => handleAction(e)}
        >
          <option value="" className="">
            Select Corporate Action
          </option>
          <option value="B" className="">
            Bonus
          </option>
          <option value="S" className="">
            Split
          </option>
          <option value="R" className="">
            Reduction
          </option>
          <option value="C" className="">
            Consolidation
          </option>
          <option value="A" className="">
            Merger
          </option>
          <option value="X" className="">
            Demerger
          </option>
          <option value="D" className="">
            Dividend
          </option>
          <option value="G" className="">
            Right
          </option>
        </select>
      </div>
    </div>
  );
};

export default CorporateActionDropDown;
